<template>
  <div v-if="!loadingPage">
    <RequestDetailsPage
      :key="requestId"
      :request="request"
      :discussion-messages="discussionMessages"
      :associated-files="associatedFiles"
      :request-assignees="requestAssignees"
    />
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import businessService from '@/Services/businessService';
import usePageLoading from '@/VueCore/utils/usePageLoading';
import Request from '@/Types/request';
import discussionService from '@/Services/discussionService';
import RequestDetailsPage from '@/VueComponents/PageComponents/RequestDetails/RequestDetailsPage.vue';
import RequestService from '@/Services/requestService';
import AssociatedFileService from '@/Services/associatedFileService';

const request = ref<Request | null>(null);
const discussionMessages = ref([]);
const associatedFiles = ref([]);
const requestAssignees = ref(null);

// Used as :key value of the component what allows to recreate it when id is changed
const requestId = ref('');

businessService.getRequestAssigneeSummaries().then(data => requestAssignees.value = data);

const { loadingPage } = usePageLoading(async params => {
  request.value = await RequestService.getRequest(params.id as string);
  associatedFiles.value = await AssociatedFileService.getAssociatedFileByRequestId(params.id as string);
  discussionMessages.value = (await discussionService.getMessagesByRequestId(params.id as string)) ?? [];
  requestId.value = params.id as string;
}, error => console.error('Failed to fetch request details:', error));
</script>
